// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1mtRq","label":"Radio_label__fmFhJ","checkMark":"Radio_checkMark__1EnHq","disabled":"Radio_disabled__2GvzS"};